export const Evento = Object.freeze({
    ACTUALIZAR_LISTA_DOCUMENTOS: "actualizar-lista-documentos"
});
